import {jsonMember, jsonObject} from "typedjson";
import {PitActivityDonor} from "./pit-activity-donor";
import {PitActivityVersion} from "./pit-activity-version";

/** Версия мероприятия «донора» */

@jsonObject
export class PitSourceActivityVersion {

  /** Уникальный идентификатор версии мероприятия */
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _id: number;

  /** Код версии мероприятия */
  @jsonMember({name: "code", constructor: String, emitDefaultValue: false, isRequired: false })
  private _code: string;

  /** Мероприятие «донор» */
  @jsonMember({name: "activity", constructor: PitActivityDonor, emitDefaultValue: false, isRequired: false })
  private _activity: PitActivityDonor = new PitActivityDonor();

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get code(): string {
    return this._code;
  }

  set code(value: string) {
    this._code = value;
  }

  get activity(): PitActivityDonor {
    return this._activity;
  }

  set activity(value: PitActivityDonor) {
    this._activity = value;
  }

  static from(activityVersion: PitActivityVersion): PitSourceActivityVersion {
    let result = new PitSourceActivityVersion();
    result.id = activityVersion.id;
    result.code = activityVersion.code;
    result.activity = PitActivityDonor.from(activityVersion.activity);
    return result;
  }
}
